import moment from 'moment-timezone';
import { DateRangeValue } from './date-range-presets';

/**
 * Builds a compact custom range label in the given timezone.
 * When range starts/ends on the same day, avoids repeating the date in the end time.
 */
export function formatCustomRangeLabel(
  value: DateRangeValue | null | undefined,
  getLabelByPresetId: (presetId: 'today' | 'yesterday') => string,
  timeZone: string,
): string | null {
  if (!value?.from || !value?.to) {
    return null;
  }

  const from = moment(value.from).tz(timeZone);
  const to = moment(value.to).tz(timeZone);
  const now = moment().tz(timeZone);

  if (!from.isSame(to, 'day')) {
    return `${from.format('DD/MM HH:mm')} - ${to.format('DD/MM HH:mm')}`;
  }

  if (from.isSame(now, 'day')) {
    return `${getLabelByPresetId('today')} ${from.format('HH:mm')} - ${to.format('HH:mm')}`;
  }

  const yesterday = now.clone().subtract(1, 'day');
  if (from.isSame(yesterday, 'day')) {
    return `${getLabelByPresetId('yesterday')} ${from.format('HH:mm')} - ${to.format('HH:mm')}`;
  }

  return `${from.format('DD/MM HH:mm')} - ${to.format('HH:mm')}`;
}
